<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import BaseBubble from '../bubbles/Base.vue';
import { useMessageContext } from '../provider.js';
import { isMasifiWaAnimatedSticker } from 'dashboard/helper/masifiWhatsappQr';

// Sticker recibido por WhatsApp QR (E2E F2 lote 3). Tamaño de sticker (160px, como en WhatsApp) sin el fondo de
// burbuja (mismo patrón que la burbuja nativa de audio: BaseBubble + bg-transparent), en vez de la foto de 512px de
// la burbuja de imagen. El animado no se puede dibujar (Lottie `.was`): se explica en vez del "no soportado" genérico.
const { attachments, contentAttributes } = useMessageContext();
const { t } = useI18n();

const attachment = computed(() => attachments.value?.[0]);
const isAnimated = computed(() =>
  isMasifiWaAnimatedSticker(contentAttributes.value)
);
const hasError = ref(false);
</script>

<template>
  <BaseBubble
    v-if="isAnimated"
    class="px-4 py-3 text-sm"
    data-bubble-name="sticker"
  >
    {{ t('MASIFI_WHATSAPP_QR.STICKER.ANIMATED') }}
  </BaseBubble>
  <BaseBubble v-else class="bg-transparent" data-bubble-name="sticker">
    <p v-if="hasError" class="mb-0 px-4 py-3 text-n-slate-11">
      {{ t('COMPONENTS.MEDIA.IMAGE_UNAVAILABLE') }}
    </p>
    <img
      v-else-if="attachment?.dataUrl"
      :src="attachment.dataUrl"
      :alt="t('MASIFI_WHATSAPP_QR.STICKER.ALT')"
      class="size-40 object-contain skip-context-menu"
      loading="lazy"
      @error="hasError = true"
    />
    <div
      v-else
      data-sticker-pending
      class="size-40 rounded-xl bg-n-alpha-2 animate-pulse"
    />
  </BaseBubble>
</template>
